/*
* 信息提示弹框通用组件
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../incs/Config.js';
import {
    ConfigProvider,
    message,
    Input,
    Modal,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { AddRequestHeaders } from '../incs/FunHelper.js';

const { TextArea } = Input;

/**
 * 信息提示框组件
 * 主要针对禁用、激活、重置和删除等操作（PATCH）
 * @param {*} props 
 * @returns 
 */
const IPModal = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const cancel = () => {
        setLoading(false);
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
    const ok = () => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}${props.uri}`,
            headers: AddRequestHeaders(),
            type: props.action === CNF.actionName.DELETE ? 'DELETE' : 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': props.action,
                'description': description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    props.setRefresh();
                    // 刷新策略
                    if (props.getPolicys) props.getPolicys();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }

        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(function () {
            setTimeout(function () {
                cancel();
            }, CNF.messageDuration * 1000);
        })
    }

    return (
        <ConfigProvider
            variant='outlined'
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR ? global.THEMECOLOR : CNF.themeColors[0],
                },
            }}
        >
            {contextHolder}
            <Modal
                title={<><ExclamationCircleFilled style={{ color: global.THEMECOLOR ? global.THEMECOLOR : CNF.themeColors[0] }} /> {props.action}{props.modulename}</>}
                closeIcon={false}
                open={open}
                onOk={ok}
                onCancel={cancel}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: description ? false : true, loading }}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要 <span style={{ color: CNF.warningColor }}><strong>{props.action}</strong></span> 该{props.modulename.replace('管理', '')}: {props.title}</p>
                    <TextArea
                        placeholder='请填写备注'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e) => { setDescription(e.target.value) }}
                        value={description}
                        disabled={loading}
                    />
                </div>
            </Modal >
        </ConfigProvider>
    );
}

export default IPModal;